export default {"src":"/_next/static/media/angle-down.46dcd260.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};